import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { BaseService } from 'src/app/services/base-service';
import { ComplementaryProduct } from 'src/app/models/configurators-2d/complementary-products/complementary-product';
import {
  AddComplementaryProductOrdersInput,
  ComplementaryProductOrder,
  LiteComplementaryProductOrder,
  UpdateComplementaryProductOrdersInput,
} from 'src/app/models/configurators-2d/complementary-products/complementary-product-order';

@Injectable({
  providedIn: 'root',
})
export class ComplementaryProductOrderService extends BaseService {
  public get baseApiUrl() {
    return environment.configurators2d.baseApi;
  }

  public get apiUrl() {
    return this.baseApiUrl + 'ComplementaryProductOrder/';
  }

  constructor() {
    super();
  }

  private buildUpdateComplementaryProductOrdersInput(
    configurationId: string,
    products: ComplementaryProduct[]
  ): UpdateComplementaryProductOrdersInput {
    let liteComplementaryProductOrders: LiteComplementaryProductOrder[] = [];
    products.forEach((product: ComplementaryProduct) => {
      liteComplementaryProductOrders.push({
        complementaryProductId: product.id,
        quantity: product.quantity,
      });
    });
    return {
      configurationId: configurationId,
      complementaryProductOrderList: liteComplementaryProductOrders,
    };
  }

  private buildAddComplementaryProductOrderInput(
    configurationId: string,
    product: ComplementaryProduct
  ): AddComplementaryProductOrdersInput {
    return {
      complementaryProductId: product.id,
      quantity: product.quantity,
      configurationId: configurationId,
    };
  }

  public async upsertListComplementaryProductOrders(
    configurationId: string,
    products: ComplementaryProduct[]
  ): Promise<boolean> {
    let orders = this.buildUpdateComplementaryProductOrdersInput(configurationId, products);
    return this.post(`${this.apiUrl}upsertList`, orders);
  }

  public async upsertComplementaryProductOrder(
    configurationId: string,
    product: ComplementaryProduct
  ): Promise<boolean> {
    let order = this.buildAddComplementaryProductOrderInput(configurationId, product);
    return this.post(`${this.apiUrl}upsert`, order);
  }
}
